import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import common_se_ronneby from './translations/se/commonRonneby.json';
import common_se_olofstrom from './translations/se/commonOlofstrom.json';
import { THEME_KEY } from './Constants';

const languages = ['se'];
const selectedlang = 'se';
const common_se = THEME_KEY === 'olofstrom' ? common_se_olofstrom : common_se_ronneby;

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({

    lng: selectedlang,
    resources: {
      se: {
        common: common_se, // 'common' is our custom namespace
      }
    },
    fallbackLng: selectedlang,
    debug: true,
    whitelist: languages,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

export default i18n;